import { render, staticRenderFns } from "./31gongyinliang.vue?vue&type=template&id=3e885e9e&scoped=true&"
import script from "./31gongyinliang.vue?vue&type=script&lang=js&"
export * from "./31gongyinliang.vue?vue&type=script&lang=js&"
import style0 from "./31gongyinliang.vue?vue&type=style&index=0&id=3e885e9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e885e9e",
  null
  
)

export default component.exports